import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { configSelector } from '../../../selectors/configSelector';
import { getJsonQuery } from '../../../selectors/getJsonQuery';
import { IRosbankBannerContainerProps } from '../../../types/rosbankBanners';
import { FDealType, FOfferType } from '../../../utils/category';
import {
  RosbankPilotBanner,
  RosbankPilotBannerSaleNew,
  RosbankPilotBannerSaleOld,
} from '../../components/RosbankPilotBanner';
import { trackRosbankPilotBannerShown, trackRosbankPilotBannerClicked, getUrlWithParams } from './utils';

/**
 * Контейнер баннера пилота с Росбанком для смешанной выдачи.
 */
export const RosbankPilotBannerContainer: React.FC<IRosbankBannerContainerProps> = ({ serpType, offerType }) => {
  const config = useSelector(configSelector);
  const searchParams = useSelector(getJsonQuery);
  const landingUrl = config.get<string>('rosbank-landing-frontend.landingUrl') || '';

  const link = getUrlWithParams(landingUrl, serpType, offerType);

  /* istanbul ignore next */
  const handleClick = () => {
    trackRosbankPilotBannerClicked(searchParams, offerType, serpType);
  };

  /* istanbul ignore next */
  const handleShow = () => {
    trackRosbankPilotBannerShown(searchParams, offerType, serpType);
  };

  const getBannerFromOfferType = (offerType: FOfferType): React.ReactElement => {
    switch (offerType) {
      case FOfferType.FlatNew:
        return <RosbankPilotBannerSaleNew url={link} onClick={handleClick} />;

      case FOfferType.FlatOld:
        return <RosbankPilotBannerSaleOld url={link} onClick={handleClick} />;

      default:
        return <RosbankPilotBanner url={link} onClick={handleClick} />;
    }
  };

  return (
    <ActionAfterViewObserver triggerOnce percentVisible={0.8} callback={handleShow}>
      {serpType === FDealType.Sale ? (
        getBannerFromOfferType(offerType)
      ) : (
        <RosbankPilotBanner url={link} onClick={handleClick} />
      )}
    </ActionAfterViewObserver>
  );
};

RosbankPilotBannerContainer.displayName = 'RosbankPilotBannerContainer';
